import { z } from 'zod';

/**
 * URL search params for the Home deslogada — search term + the four filter
 * dimensions of the Figma filter modal (job type, work model, workload,
 * location). Filters are bookmarkable/shareable; the filter UI itself is an
 * overlay, not a route.
 */
export const opportunitiesSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  jobType: z.string().optional().catch(undefined),
  workModel: z.string().optional().catch(undefined),
  workload: z.string().optional().catch(undefined),
  state: z.string().optional().catch(undefined),
  city: z.string().optional().catch(undefined),
});

export type OpportunitiesSearch = z.infer<typeof opportunitiesSearchSchema>;
